import { render, staticRenderFns } from "./major.vue?vue&type=template&id=dd224d32&scoped=true"
import script from "./major.vue?vue&type=script&lang=js"
export * from "./major.vue?vue&type=script&lang=js"
import style0 from "./major.vue?vue&type=style&index=0&id=dd224d32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd224d32",
  null
  
)

export default component.exports